$(function () {
  var calculator = $('.calculator')
  if (calculator.length === 0) return

  var seats = $('#calc-seats')
  var yearly = $('#calc-yearly')

  // The previous version applied a 10% volume discount above 20 seats and hid
  // the price entirely above 50, neither of which exists: Stripe carries one
  // rate, $15 per seat per month or $150 per seat per year.
  var MONTHLY_UNIT = 15
  var YEARLY_UNIT = 150

  var calculate = function () {
    var count = Math.max(1, Number(seats.val()) || 1)
    var isYearly = yearly.prop('checked')
    var unit = isYearly ? YEARLY_UNIT : MONTHLY_UNIT
    var key = isYearly ? 'pricing.per-year-short' : 'pricing.per-month-short'
    // i18next is loaded by the shared footer bundle; the literals are the
    // fallback for the brief window before it initialises.
    var suffix =
      typeof i18next !== 'undefined' && i18next.t ? i18next.t(key) : isYearly ? '/yr' : '/mo'

    calculator.find('.total').text('$' + count * unit + ' ' + suffix)
    calculator.find('.billing-period .period').removeClass('active')
    calculator.find('.billing-period .period[data-period="' + (isYearly ? 'year' : 'month') + '"]').addClass('active')
  }

  $('#calc-seats, #calc-yearly').on('change input', calculate)
  calculate()
})
